import { render, staticRenderFns } from "./HeadquarterList.vue?vue&type=template&id=66fff0ed&"
import script from "./HeadquarterList.vue?vue&type=script&lang=ts&"
export * from "./HeadquarterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports